import type { ReactNode } from 'react';

interface BadgeProps {
  children: ReactNode;
  variant?: 'default' | 'live' | 'success' | 'warning';
}

const variantClasses = {
  default: 'bg-white/10 text-white',
  live: 'badge-live',
  success: 'bg-success/20 text-success',
  warning: 'bg-warning/20 text-warning',
} as const;

export function Badge({ children, variant = 'default' }: BadgeProps) {
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${variantClasses[variant]}`}>
      {children}
    </span>
  );
}
